module.exports = __webpack_public_path__ + "img/38.7e53a00.jpg";